export const mediaUrl = (value) => {
  if (!value) return "";
  if (value.startsWith("http://") || value.startsWith("https://") || value.startsWith("blob:")) return value;
  return `${process.env.REACT_APP_BACKEND_URL}${value.startsWith("/") ? value : `/${value}`}`;
};